<template>
  <div class="form-group">
    <div class="checkbox" :class="{ '-checked': checkboxValue }">
      <label class="form-check-label" :for="identifier">
        <input :id="identifier" type="checkbox" :name="identifier" :value="value" v-model="checkboxValue" required>
        <span v-html="$t('overlay.form.privacy', {link: globals.privacylink, privacy: $t('overlay.form.privacyLabel')})"></span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useGlobalStore } from '@/stores'

const globals = useGlobalStore()

const props = defineProps({
    identifier: {
        type: String,
        default: ''
    },
    value: {
        type: Boolean,
        default: null
    }
})

const emit = defineEmits(['update:modelValue'])

const checkboxValue = computed({
    get () {
        return props.value
    },
    set (value) {
        emit('update:modelValue', value)
    }
})
</script>
